import React, { useEffect, useState } from 'react';
import ConfigPanelBody from '../ConfigPanelBody';
import ConfigPanelFooter from '../ConfigPanelFooter';
import ButtonDefault from '../../../buttons/ButtonDefault';
import ButtonPrimary from '../../../buttons/ButtonPrimary';
import { useOperator } from './OperatorProvider';
import sharedSource from '../../../../sources/shared';
import FormGroup from '../../../generic/FormGroup';

const MacroDetails = () => {
    const {
        mapElement,
        setCurrentScreen,
        selectedOperationIndex,
        setSelectedOperationIndex,
        OPERATOR_SCREENS,
        tenantId,
        authenticationToken,
        notifyError,
    } = useOperator();

    const [macros, setMacros] = useState([]);
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const [selectedMacroId, setSelectedMacroId] = useState(
        mapElement.operations?.[selectedOperationIndex]?.macroElementToExecuteId ?? null,
    );

    const isValid = selectedMacroId !== null;

    const onSave = () => {
        setHasSubmitted(true);
        if (isValid) {
            const index = selectedOperationIndex ?? mapElement.operations.length;
            const operation = {
                macroElementToExecuteId: selectedMacroId,
                macroElementToExecuteDeveloperName: macros.find(
                    (macro) => macro.id === selectedMacroId,
                ).developerName,
            };

            mapElement.operations[index] = operation;

            setCurrentScreen(OPERATOR_SCREENS.configuration);
        }
    };

    const onCancel = () => {
        setCurrentScreen(OPERATOR_SCREENS.configuration);
        setSelectedOperationIndex(null);
    };

    const getMacros = () => {
        sharedSource
            .getAll('macro', tenantId, authenticationToken)
            .then((response) => {
                setMacros(JSON.parse(response));
            })
            .catch(notifyError);
    };

    useEffect(() => {
        getMacros();
    }, []);

    return (
        <>
            <ConfigPanelBody>
                <h3 className="margin-top-small">{`Macro for: ${mapElement.developerName}`}</h3>

                <FormGroup
                    label="Which Macro do you want to run?"
                    isRequired
                    isValid={isValid}
                    validationMessage="Please select a macro to run."
                    showValidation={hasSubmitted}
                >
                    <select
                        data-testid="macro-select"
                        className="form-control form-select form-control-width"
                        value={selectedMacroId ?? ''}
                        onChange={({ target: { value } }) => setSelectedMacroId(value)}
                    >
                        {selectedMacroId === null && <option value="">Select a Macro</option>}
                        {macros.map((macro) => (
                            <option value={macro.id} key={macro.id}>{macro.developerName}</option>
                        ))}
                    </select>
                </FormGroup>
            </ConfigPanelBody>
            <ConfigPanelFooter>
                <ButtonDefault className="flex-child-right" onClick={onCancel}>
                    Cancel
                </ButtonDefault>
                <ButtonPrimary className="margin-left" onClick={onSave}>
                    {selectedOperationIndex === null ? 'Add' : 'Update'}
                </ButtonPrimary>
            </ConfigPanelFooter>
        </>
    );
};

export default MacroDetails;
